import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router";

import { ROUTE_PATHS } from "@/shared/constants/route-paths";
import { Button } from "@/shared/ui/button";
import { Skeleton } from "@/shared/ui/skeleton";

const RUN_CARD_SKELETONS = ["run-1", "run-2", "run-3"];

export function FlowDetailPageLoading() {
  const navigate = useNavigate();

  return (
    <div className="h-full overflow-y-auto">
      <div className="min-h-full py-6">
        <Button
          className="mb-4 gap-2"
          onClick={() => navigate(ROUTE_PATHS.MINE_WORKFLOW)}
          variant="ghost"
        >
          <ArrowLeft className="size-4" />
          返回流程列表
        </Button>

        <div aria-label="正在加载流程详情" className="mb-5" role="status">
          <div className="flex items-center gap-2">
            <Skeleton className="h-6 w-36" />
            <Skeleton className="h-5 w-12 rounded-full" />
          </div>
          <Skeleton className="mt-2 h-4 w-2/3 max-w-xl" />
        </div>

        <section>
          <h2 className="mb-3 text-sm font-medium">执行记录</h2>
          <div className="space-y-2">
            {RUN_CARD_SKELETONS.map((id) => (
              <div className="flex items-center gap-3 rounded-lg bg-background px-3 py-3" key={id}>
                <Skeleton className="size-4 shrink-0 rounded-full" />
                <div className="min-w-0 flex-1">
                  <Skeleton className="h-4 w-28" />
                  <Skeleton className="mt-2 h-3 w-40" />
                </div>
                <Skeleton className="h-3 w-12" />
                <Skeleton className="size-4" />
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
